import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  FormModeEnum,
  ModalService,
  BackendService,
  NotificationService,
  FieldMapItem,
  TableActionEnum,
  TableSettings,
} from 'beyond-util';
import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../services/backend.service';
import { FormCode } from '../../enums/form-code.enum';
import { FormName } from '../../enums/form-name.enum';
import { EndpointTypes } from '../../enums/enpoint-types.enum';
import { EnumService } from '../../services/enum.service';
import { Observable } from 'rxjs/Observable';
import moment = require('moment');

@Component({
  selector: 'app-zeljene-pozicije',
  templateUrl: './zeljene-pozicije.component.html',
})
export class ZeljenePozicijeComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;
  private datumOd: any;
  private datumDo: any;
  private programId: string;

  public initialLoad = true;
  public hardEditableColumnNames = ['SpotZeljenaPozicija'];
  public selectedEmisija: any;
  public datumOdFieldSettings: FieldMapItem;
  public datumDoFieldSettings: FieldMapItem;
  public emisijaFieldSettings: FieldMapItem;

  oldFilterQuery: string;

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _enumService: EnumService,
    private _rtsBackendService: RtsBackendService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
      this._enumService.fetchProgrami();
      this._enumService.registerZeljenePozicije();
    });

    const lookupSettngs = this.getEmisijaFilterSettings();
    const lookupSettngsTable = new TableSettings(lookupSettngs, 'table');
    this.emisijaFieldSettings = lookupSettngsTable.getFieldByName(
      'Emisija'
    );
    this.setInitEmisijeFilter();
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  loadSettings() {
    this.oldFilterQuery = `${this.filterQuery}`;

    if (this.selectedEmisija != undefined) {
      this.filterQuery += "&emisijaId=" + this.selectedEmisija.Id;
    }
    
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_POZ,
      FormName.MediaPlan,
      this.initialLoad === true ? EndpointTypes.GetModelData : EndpointTypes.GetAllEntities,
      this.filterQuery
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          this._spinner.hide();

          if (this.hasError(response)) {
            this.notifyError(response['Errors'][0]['ErrorMessage']);

            return;
          }

          if (!this.settingsTable) {
            const settings = this.alterSettings(response);
            this.setSettings(settings);
          }

          this.oldFilterQuery = this.filterQuery;
          this._data = response.ServiceData.Data;
          this._dataCount = response.ServiceData.DataSumCount;
          if (this._data && this._data.length) {
            this.setColorForRezervacije();
          }

          this.setAllFields();
          this.refreshTable();
          this.changeMode(FormModeEnum.Table);
        })
    );
  }

  setColorForRezervacije() {
    this._data.forEach(r => {
      if (r.Status > 1) {
        r.color = 'danger';
      }
    });
  }

  setInitEmisijeFilter() {
    this.emisijaFieldSettings.lookupInitFilter = [];
  }

  hasError(response: any) {
    return (
      response['Errors'] &&
      response['Errors'].length &&
      response['Errors'][0]['ErrorMessage']
    );
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    this.initialLoad = false;
    super.onTableActionFilter(event);
    
  }

  onSelectedEmisijaChange(event) {
    this.selectedEmisija = event.value;
  }

  alterSettings(data: any) {
    const settings = { ...data.Settings };
    const rbrField = (<any[]>data.Settings.allFields).find(
      x => x.fieldKey === 'RedniBroj'
    );

    settings.allFields
      .filter(f => f.fieldKey !== 'SpotZeljenaPozicija')
      .forEach(ff => (ff.editable = false));

    rbrField.width = 1;

    settings.inlineEditing = true;
    settings.inlineAdding = true;
    settings.additable = false;
    settings.deletable = false;
    settings.editable = true;

    return settings;
  }

  refreshTable() {
    if (this._data != undefined) {
      this._data.forEach(d => (d['id'] = d.Id));
      this._data.forEach(d => (d['rbr'] = d.Id));
    }
    
    this.orderList = this._data;
    
    this.orderListCount = this._dataCount;
  }

  resetFilters() {
    this.datumOd = undefined;
    this.datumDo = undefined;
    this.programId = undefined;
    this.selectedEmisija = null;
    this.emisijaFieldSettings.lookupInitFilter = [
      { name: 'DatumOd', value: undefined },
      { name: 'DatumDo', value: undefined },
      { name: 'ProgramId', value: undefined },
    ];
  }

  getSelectedObjects() {
    const selected = this.orderList.filter(x => x.selected);

    return selected;
  }

  valueChanged(event) {
    if (event != undefined && event.fieldMap != undefined) {
      switch (event.fieldMap.fieldKey) {
        case 'DatumOd':
          this.datumOd = event.newValue;
          break;
        case 'DatumDo':
          this.datumDo = event.newValue;
          break;
        case 'ProgramId':
          this.programId = event.newValue;
          break;
      }
    }
    this.emisijaFieldSettings.lookupInitFilter = [
      { name: 'DatumOd', value: this.datumOd != undefined ? moment(this.datumOd).format('yyyy-MM-DD') : undefined },
      { name: 'DatumDo', value: this.datumDo != undefined ? moment(this.datumDo).format('yyyy-MM-DD') : undefined },
      { name: 'ProgramId', value: this.programId },
    ];
  }

  rezervacijeTableAction(event, isFilter: boolean) {
    switch (event.action) {
      case TableActionEnum.Select:
        break;

      case TableActionEnum.Filter:
        event.isFilterEvent = isFilter;
        this.onTableActionFilter(event);
        break;

      case TableActionEnum.Edit:
        this._orderBeforeEditing = { ...this.order };
        this._subscriptions.push(
          this.validateRezervacija(event.document).subscribe(valid => {
            if (this.hasError(valid)) {
              event.document.cantUpdateMessage =
                valid['Errors'][0]['ErrorMessage'];
            } else {
              event.document.cantUpdateMessage = null;
            }
          })
        );

        break;
      case TableActionEnum.EditCancel:
        this.copyProperties(this._orderBeforeEditing, this.order);
        break;
      case TableActionEnum.BeforeSave:
        break;

      case TableActionEnum.Update:
        this._spinner.show();
        this._subscriptions.push(
          this.checkExistenceOfUvecanjeZeljenaPozicija(
            event.document.PodugovorId,
            event.document.SpotZeljenaPozicija
          ).subscribe((result: any) => {
            if (result && !result.ServiceData) {
              this.notify(
                'Korekcija za željenu poziciju ne postoji na podugovoru. Rezervacija će biti izmenjena.'
              );
            }

            this.updateRezervacijaObs(event.document).subscribe(
              res => {
                const serviceData = res.ServiceData;
                if (serviceData != null && serviceData.Success) {
                  this._spinner.hide();
                  this.notify(
                    'Uspešno ažurirana željena pozicija rezervacije.'
                  );
                } else {
                  this._spinner.hide();
                  this.notifyError(
                    'Desila se greška prilikom ažuriranja željene pozicije rezervacije.'
                  );
                  this._spinner.hide();
                }
              },
              error => {
                this._spinner.hide();
                this.notifyError(
                  'Desila se greška prilikom ažuriranja željene pozicije rezervacije.'
                );
              }
            );
          })
        );
        break;
    }
  }

  updateRezervacijaObs(order): Observable<any> {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_RAPUB,
      FormName.MediaPlan,
      EndpointTypes.PutEntity,
      null,
      order,
      true,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  validateRezervacija(order): Observable<any> {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_VALREZ,
      FormName.MediaPlan,
      EndpointTypes.PostEntity,
      null,
      order,
      true,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  checkExistenceOfUvecanjeZeljenaPozicija(
    podugovorId: string,
    zeljenaPozicija: string
  ): Observable<any> {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSUGO_PKUUB,
      FormName.MediaPlan,
      EndpointTypes.GetSingleEntity,
      `?podugovorId=${podugovorId}&zeljenaPozicijaUBloku=${zeljenaPozicija}`,
      null,
      true,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  getEmisijaFilterSettings() {
    return {
      additable: true,
      allFields: [
        this.getEmisijaLookupSettings(),
      ],
      completerMainAndSecond: false,
      completerMainField: null,
      completerSecondField: null,
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        table: []
      },
      fromCode: '',
      group: 'Emisija',
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name: 'Montaza',
      relations: [
        this.getRelationSettings(
          'Emisija',
          'Naziv',
          'Sifra',
          [this.getEmisijaLookupSettings().id]
        ),
      ],
      title: 'Emisija',
      type: 'Emisija',
      path: '',
      _id: '51073157',
    };
  }

  getEmisijaLookupSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Emisija',
      entityType: 'Emisija',
      id: '777-777-777',
      label: 'Emisija',
      lookupFormCode: FormCode.MSEMI_EMIDO,
      lookupFormName: FormName.PregledZeljenihPozicija,
      mandatory: false,
      name: 'Emisija',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getRelationSettings(
    name: string,
    completerMainField: string,
    completerSecondField: string,
    lookupTable: Array<any>
  ) {
    return {
      additable: true,
      allFields: [],
      completerMainAndSecond: true,
      completerMainField,
      completerSecondField,
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: [],
        lookupTable,
      },
      fromCode: '',
      group: name,
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name,
      relations: [],
      title: name,
      type: name,
      _id: '51073157',
    };
  }

}




// WEBPACK FOOTER //
// ./src/app/pages/zeljene-pozicije/zeljene-pozicije.component.ts